import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import CardDetail from "components/CardDetail";
import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import LoadingSpin from "components/Loading";
import ScrollUpBtn from "components/ScrollUpBtn";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  NameCourse,
  SubDetail,
  SubHead,
  SubTitle,
  TextBold,
  TextHead,
  TextName,
  TextNote,
  TextPosition,
  Title,
  TitleEN,
  View,
} from "./public_health.style";

import stuView from "assets/images/png/student_comp-01.png";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import iconPDFPink from "assets/images/svg/icon-file-pdf-pink.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

function PublicHealthDepartment({ selectYear, year }) {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=2024`,
      { incrementVisitor: true }
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=2024`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const spliteLinkRegis = (link, text, style) => {
    const newLink = link.split(text);
    return (
      <div className={style !== "" ? `link-web ${style}` : "link-web"}>
        {text}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const renderDetailLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <DetailLink bottom="0" color={ListColor1[slang]}>
          {name}
        </DetailLink>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  const getHighlightedText = (text, highlight, color) => {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase()
                ? { color: color }
                : { color: "#353535" }
            }
          >
            {part}
          </span>
        ))}
      </span>
    );
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} minBeYear={2567} />
        </div>

        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>
                            {" "}
                            {breadcrumbName[item]}
                          </Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>

            {windowWidth <= 1280
              ? departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ maxWidth: "104px", width: "100%" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      <div className="col-image-profile">
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.message?.image &&
                              departmentData?.message?.image[0]?.image_0
                            }
                            alt="dean"
                            style={{ marginTop: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      </div>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>
                                  {getHighlightedText(
                                    item?.text_0,
                                    `â€œà¸¢à¸´à¸™à¸”à¸µà¸•à¹‰à¸­à¸™à¸£à¸±à¸šà¸™à¹‰à¸­à¸‡à¹ƒà¸«à¸¡à¹ˆà¸—à¸¸à¸à¸„à¸™â€`,
                                    "#F28DBA"
                                  )}
                                </DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_1,
                                    `â€œà¸‚à¸­à¸„à¸§à¸²à¸¡à¸£à¹ˆà¸§à¸¡à¸¡à¸·à¸­à¸ˆà¸²à¸à¸žà¸§à¸à¹€à¸£à¸²à¸—à¸¸à¸à¸„à¸™à¸—à¸µà¹ˆà¸ˆà¸°à¸žà¸±à¸’à¸™à¸²à¸•à¸±à¸§à¹€à¸­à¸‡à¸£à¹ˆà¸§à¸¡à¸à¸±à¸™â€`,
                                    "#8ADD96"
                                  )}
                                </DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_2,
                                    `â€œà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸²â€`,
                                    "#4675B5"
                                  )}
                                </DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_3,
                                    `â€œà¸¡à¸µà¸„à¸§à¸²à¸¡à¸ªà¸¸à¸‚à¹ƒà¸™à¸à¸²à¸£à¹€à¸£à¸µà¸¢à¸™ à¸£à¸¹à¹‰à¸«à¸™à¹‰à¸²à¸—à¸µà¹ˆ à¸£à¸±à¸šà¸œà¸´à¸”à¸Šà¸­à¸šà¸•à¸™à¹€à¸­à¸‡ à¸”à¸¹à¹à¸¥à¸à¸²à¸¢à¹ƒà¸ˆà¸‚à¸­à¸‡à¸•à¸™à¹ƒà¸«à¹‰à¸”à¸µà¹ƒà¸Šà¹‰à¸›à¸±à¸à¸à¸²à¹ƒà¸™à¸à¸²à¸£à¸”à¸³à¹€à¸™à¸´à¸™à¸Šà¸µà¸§à¸´à¸•à¸­à¸¢à¹ˆà¸²à¸‡à¸£à¸°à¸¡à¸±à¸”à¸£à¸°à¸§à¸±à¸‡â€`,
                                    "#F28DBA"
                                  )}
                                </DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            ></Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )
              : departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ width: "104px" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>
                                  {getHighlightedText(
                                    item?.text_0,
                                    `â€œà¸¢à¸´à¸™à¸”à¸µà¸•à¹‰à¸­à¸™à¸£à¸±à¸šà¸™à¹‰à¸­à¸‡à¹ƒà¸«à¸¡à¹ˆà¸—à¸¸à¸à¸„à¸™â€`,
                                    "#F28DBA"
                                  )}
                                </DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_1,
                                    `â€œà¸‚à¸­à¸„à¸§à¸²à¸¡à¸£à¹ˆà¸§à¸¡à¸¡à¸·à¸­à¸ˆà¸²à¸à¸žà¸§à¸à¹€à¸£à¸²à¸—à¸¸à¸à¸„à¸™à¸—à¸µà¹ˆà¸ˆà¸°à¸žà¸±à¸’à¸™à¸²à¸•à¸±à¸§à¹€à¸­à¸‡à¸£à¹ˆà¸§à¸¡à¸à¸±à¸™â€`,
                                    "#8ADD96"
                                  )}
                                </DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_2,
                                    `â€œà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸²â€`,
                                    "#4675B5"
                                  )}
                                </DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>
                                  {getHighlightedText(
                                    item?.text_3,
                                    `â€œà¸¡à¸µà¸„à¸§à¸²à¸¡à¸ªà¸¸à¸‚à¹ƒà¸™à¸à¸²à¸£à¹€à¸£à¸µà¸¢à¸™ à¸£à¸¹à¹‰à¸«à¸™à¹‰à¸²à¸—à¸µà¹ˆ à¸£à¸±à¸šà¸œà¸´à¸”à¸Šà¸­à¸šà¸•à¸™à¹€à¸­à¸‡ à¸”à¸¹à¹à¸¥à¸à¸²à¸¢à¹ƒà¸ˆà¸‚à¸­à¸‡à¸•à¸™à¹ƒà¸«à¹‰à¸”à¸µà¹ƒà¸Šà¹‰à¸›à¸±à¸à¸à¸²à¹ƒà¸™à¸à¸²à¸£à¸”à¸³à¹€à¸™à¸´à¸™à¸Šà¸µà¸§à¸´à¸•à¸­à¸¢à¹ˆà¸²à¸‡à¸£à¸°à¸¡à¸±à¸”à¸£à¸°à¸§à¸±à¸‡â€`,
                                    "#F28DBA"
                                  )}
                                </DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            >
                              <FadeInSection axis="y">
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="dean"
                                  width={"100%"}
                                />
                              </FadeInSection>
                            </Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )}

            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      {departmentData?.contract[0]?.department}
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <Href
                            to={item?.slang}
                            rel="noopener noreferrer"
                            target={"_self"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¸žà¸¢à¸²à¸šà¸²à¸¥ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¹à¸žà¸—à¸¢à¹Œà¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.misstion && (
              <Element name={departmentData?.misstion?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="50">
                    {departmentData?.misstion?.title}
                  </SubTitle>
                  <Row gutter={24} className="row-detail-card">
                    {departmentData?.misstion?.data.map((item, index) => {
                      return (
                        index < 3 && (
                          <>
                            <Col span={8} key={index}>
                              <FadeInSection axis="x">
                                <img
                                  loading="lazy"
                                  src={item?.image ? item?.image : engineer}
                                  alt="misstion"
                                  style={{
                                    width: "100%",
                                    borderRadius: "20px",
                                    marginBottom: "20px",
                                  }}
                                />
                              </FadeInSection>
                              <SubHead font="Noto Sans Thai Bold">
                                {item?.title}
                              </SubHead>

                              {item?.text_0 && (
                                <SubDetail
                                  top="0"
                                  bottom={
                                    index === 0 &&
                                    departmentData?.misstion?.data[3]
                                      ? "35"
                                      : "0"
                                  }
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_0}
                                </SubDetail>
                              )}
                              {index === 0 &&
                                departmentData?.misstion?.data[3] && (
                                  <>
                                    <SubHead font="Noto Sans Thai Bold">
                                      {departmentData?.misstion?.data[3]?.title}
                                    </SubHead>
                                    {departmentData?.misstion?.data[3]
                                      ?.text_0 && (
                                      <SubDetail
                                        top="0"
                                        bottom="0"
                                        color="var(--black)"
                                      >
                                        {
                                          departmentData?.misstion?.data[3]
                                            ?.text_0
                                        }
                                      </SubDetail>
                                    )}
                                  </>
                                )}
                              {item?.text_1 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_1}
                                </SubDetail>
                              )}
                              {item?.text_2 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_2}
                                </SubDetail>
                              )}
                              {item?.text_3 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_3}
                                </SubDetail>
                              )}
                              {item?.text_4 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_4}
                                </SubDetail>
                              )}
                              {item?.text_5 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_5}
                                </SubDetail>
                              )}
                              {item?.text_6 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_6}
                                </SubDetail>
                              )}
                              {item?.text_7 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_7}
                                </SubDetail>
                              )}
                            </Col>
                          </>
                        )
                      );
                    })}
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.about && (
              <Element name={departmentData?.about?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.about?.title}</SubTitle>
                    {departmentData?.about?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail indent="32" bottom="20">
                              {item?.text_0}
                            </SubDetail>
                          )}

                          {item?.text_2 && (
                            <TextHead
                              indent="32"
                              style={{ marginLeft: "30px" }}
                            >
                              {item?.text_2}
                            </TextHead>
                          )}
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.about?.image &&
                      departmentData?.about?.image.map((item) => {
                        return (
                          <FadeInSection axis="y">
                            <CustomCarousel
                              autoplay
                              bg={ListColor1[slang]}
                              speed="500"
                            >
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })}
                  </Col>
                </Row>
                {departmentData?.about &&
                  departmentData?.about.text &&
                  departmentData?.about?.text.map((item) => {
                    return (
                      <>
                        <Row
                          gutter={24}
                          className="row-group"
                          style={{ marginTop: "0px" }}
                        >
                          <Col span={11}>
                            {item?.text_13 && (
                              <TextBold bottom="20">{item?.text_3}</TextBold>
                            )}
                            {item?.text_4 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_4}
                              </SubDetail>
                            )}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_6}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_7}
                              </SubDetail>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_8}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_9}
                              </SubDetail>
                            )}
                            {item?.text_10 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_10}
                              </SubDetail>
                            )}
                            {item?.text_11 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_11}
                              </SubDetail>
                            )}
                            {item?.text_12 && (
                              <SubDetail top="0">{item?.text_12}</SubDetail>
                            )}
                          </Col>
                          <Col span={12} offset={1}>
                            {item?.text_13 && (
                              <TextBold
                                bottom="20"
                                style={{ marginLeft: "30px" }}
                              >
                                {item?.text_13}
                              </TextBold>
                            )}
                            {item?.text_14 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_14}
                              </SubDetail>
                            )}
                            {item?.text_15 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_15}
                              </SubDetail>
                            )}
                            {item?.text_16 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_16}
                              </SubDetail>
                            )}
                            {item?.text_17 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_17}
                              </SubDetail>
                            )}
                            {item?.text_18 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_18}
                              </SubDetail>
                            )}
                            {item?.text_19 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_19}
                              </SubDetail>
                            )}
                            {item?.text_20 && (
                              <SubDetail top="0">{item?.text_20}</SubDetail>
                            )}
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "0px" }}>
                          <Col span={24}>
                            {item?.text_21 && (
                              <TextBold
                                bottom="20"
                                style={{ marginLeft: "30px" }}
                              >
                                {item?.text_21}
                              </TextBold>
                            )}
                            {item?.text_22 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_22}
                              </SubDetail>
                            )}
                            {item?.text_23 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_23}
                              </SubDetail>
                            )}
                            {item?.text_24 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_24}
                              </SubDetail>
                            )}
                            {item?.text_25 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_25}
                              </SubDetail>
                            )}
                            {item?.text_26 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_26}
                              </SubDetail>
                            )}
                            {item?.text_27 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_27}
                              </SubDetail>
                            )}
                            {item?.text_28 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_28}
                              </SubDetail>
                            )}

                            {item?.text_29 && (
                              <SubDetail top="0">{item?.text_29}</SubDetail>
                            )}
                          </Col>
                        </Row>
                      </>
                    );
                  })}
              </Element>
            )}

            {departmentData?.evaluation_student && (
              <Element name={departmentData?.evaluation_student?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.evaluation_student?.image ? (
                        departmentData?.evaluation_student?.image.map(
                          (item) => {
                            return (
                              <FadeInSection axis="x">
                                <CustomCarousel autoplay bg={ListColor1[slang]}>
                                  {item?.image_0 && (
                                    <img
                                      loading="lazy"
                                      src={item?.image_0}
                                      alt="icon group"
                                      style={{
                                        borderRadius: "20px",
                                        width: "100%",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  )}
                                  {item?.image_1 && (
                                    <img
                                      loading="lazy"
                                      src={item?.image_1}
                                      alt="icon group"
                                      style={{
                                        borderRadius: "20px",
                                        width: "100%",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  )}
                                  {item?.image_2 && (
                                    <img
                                      loading="lazy"
                                      src={item?.image_2}
                                      alt="icon group"
                                      style={{
                                        borderRadius: "20px",
                                        width: "100%",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  )}
                                </CustomCarousel>
                              </FadeInSection>
                            );
                          }
                        )
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>
                        {departmentData?.evaluation_student?.title}
                      </SubTitle>
                      {departmentData?.evaluation_student?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}

                            {item?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_4}
                              </SubDetail>
                            )}

                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_6}
                              </SubDetail>
                            )}

                            {item?.text_7 && (
                              <SubHead bottom="10">{item?.text_7}</SubHead>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLink(item?.text_8, "1) Log in : ")}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_9}
                              </SubDetail>
                            )}
                            {item?.text_10 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_10}
                              </SubDetail>
                            )}
                            {item?.text_11 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_11}
                              </SubDetail>
                            )}

                            {item?.text_12 && (
                              <TextNote>{item?.text_12}</TextNote>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                  {departmentData?.evaluation_course && (
                    <>
                      <SubHead bottom="20" top="20">
                        {departmentData?.evaluation_course?.title}
                      </SubHead>

                      {departmentData?.evaluation_course?.text &&
                        departmentData?.evaluation_course?.text[0]?.text_0 && (
                          <SubDetail indent="32" top="0">
                            {departmentData?.evaluation_course?.text[0]?.text_0}
                          </SubDetail>
                        )}
                    </>
                  )}
                </FixBox>
              </Element>
            )}

            {departmentData?.end && (
              <Element name={departmentData?.end?.title}>
                <SubTitle top="50">{departmentData?.end?.title}</SubTitle>
                {departmentData?.end?.text &&
                  departmentData?.end?.text[0]?.text_0 && (
                    <SubDetail indent="35">
                      {departmentData?.end?.text[0]?.text_0}
                    </SubDetail>
                  )}

                {departmentData?.end_1 && departmentData?.end_2 && (
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.end_1?.image &&
                            departmentData?.end_1?.image[0]?.image_0
                          }
                          alt="pros icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "0 0 20px 0",
                          }}
                        />
                      </FadeInSection>
                      <SubHead bottom="20">
                        {departmentData?.end_1?.title}
                      </SubHead>
                      {departmentData?.end_1?.text[0]?.text_0 && (
                        <>
                          <SubDetail top="0" indent="32">
                            {departmentData?.end_1?.text[0]?.text_0}
                          </SubDetail>
                          <SubHead bottom="0">à¸­à¸²à¸Šà¸µà¸žà¸—à¸µà¹ˆà¹€à¸à¸µà¹ˆà¸¢à¸§à¸‚à¹‰à¸­à¸‡</SubHead>
                          <TextPosition top="0" bottom="0">
                            {departmentData?.end_1?.text[0]?.text_1}
                          </TextPosition>
                          {departmentData?.end_1?.text[0]?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.end_1?.text[0]?.text_2}
                            </SubDetail>
                          )}
                          <TextPosition top="0" bottom="0">
                            {departmentData?.end_1?.text[0]?.text_3}
                          </TextPosition>
                          {departmentData?.end_1?.text[0]?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.end_1?.text[0]?.text_4}
                            </SubDetail>
                          )}
                          {departmentData?.end_1?.text[0]?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.end_1?.text[0]?.text_5}
                            </SubDetail>
                          )}
                          {departmentData?.end_1?.text[0]?.text_6 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.end_1?.text[0]?.text_6}
                            </SubDetail>
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={12}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.end_2?.image &&
                            departmentData?.end_2?.image[0]?.image_0
                          }
                          alt="pros icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "0 0 20px 0",
                          }}
                        />
                      </FadeInSection>
                      <SubHead bottom="20">
                        {departmentData?.end_2?.title}
                      </SubHead>

                      {departmentData?.end_2?.text &&
                        departmentData?.end_2?.text[0]?.text_0 && (
                          <>
                            <SubDetail top="0" indent="32">
                              {departmentData?.end_2?.text[0]?.text_0}
                            </SubDetail>
                            <SubHead bottom="0">
                              {departmentData?.end_2?.text[0]?.text_1}
                            </SubHead>
                            <TextPosition top="0" bottom="0">
                              {departmentData?.end_2?.text[0]?.text_2}
                            </TextPosition>
                            {departmentData?.end_2?.text[0]?.text_3 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_2?.text[0]?.text_3}
                              </SubDetail>
                            )}
                            <TextPosition top="0" bottom="0">
                              {departmentData?.end_2?.text[0]?.text_4}
                            </TextPosition>
                            {departmentData?.end_2?.text[0]?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_2?.text[0]?.text_5}
                              </SubDetail>
                            )}
                            {departmentData?.end_2?.text[0]?.text_6 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_2?.text[0]?.text_6}
                              </SubDetail>
                            )}
                            {departmentData?.end_2?.text[0]?.text_7 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_2?.text[0]?.text_7}
                              </SubDetail>
                            )}
                          </>
                        )}
                    </Col>
                  </Row>
                )}

                {departmentData?.end_3 && (
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.end_3?.image &&
                            departmentData?.end_3?.image[0]?.image_0
                          }
                          alt="pros icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "0 0 20px 0",
                          }}
                        />
                      </FadeInSection>
                      <SubHead bottom="20">
                        {departmentData?.end_3?.title}
                      </SubHead>

                      {departmentData?.end_3?.text &&
                        departmentData?.end_3?.text[0]?.text_0 && (
                          <>
                            <SubDetail top="0" indent="32">
                              {departmentData?.end_3?.text[0]?.text_0}
                            </SubDetail>
                            <SubHead bottom="0">
                              {departmentData?.end_3?.text[0]?.text_1}
                            </SubHead>
                            <TextPosition top="0" bottom="0">
                              {departmentData?.end_3?.text[0]?.text_2}
                            </TextPosition>
                            {departmentData?.end_3?.text[0]?.text_3 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_3}
                              </SubDetail>
                            )}
                            {departmentData?.end_3?.text[0]?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_4}
                              </SubDetail>
                            )}
                            {departmentData?.end_3?.text[0]?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_5}
                              </SubDetail>
                            )}
                            {departmentData?.end_3?.text[0]?.text_6 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_6}
                              </SubDetail>
                            )}

                            <TextPosition top="0" bottom="0">
                              {departmentData?.end_3?.text[0]?.text_7}
                            </TextPosition>
                            {departmentData?.end_3?.text[0]?.text_8 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_8}
                              </SubDetail>
                            )}
                            {departmentData?.end_3?.text[0]?.text_9 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_9}
                              </SubDetail>
                            )}
                            {departmentData?.end_3?.text[0]?.text_10 && (
                              <SubDetail top="0" bottom="0" indent="35">
                                {departmentData?.end_3?.text[0]?.text_10}
                              </SubDetail>
                            )}
                          </>
                        )}
                    </Col>
                  </Row>
                )}
              </Element>
            )}

            {departmentData?.study && (
              <>
                <Element name={departmentData?.study?.title}>
                  <FixBox bg={ListColor2[slang]}>
                    <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                    {departmentData?.study?.sub_title && (
                      <SubDetail indent="32">
                        {departmentData?.study?.sub_title}
                      </SubDetail>
                    )}
                    <Row gutter={24} className="row-detail-card">
                      {departmentData?.study?.data &&
                        departmentData?.study?.data.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <CardDetail
                                src={item?.image}
                                detail={item?.detail}
                              />
                            </Col>
                          );
                        })}
                    </Row>
                  </FixBox>
                </Element>
              </>
            )}

            {departmentData?.teacher && (
              <Element name={departmentData?.teacher?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                    {departmentData?.teacher?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail indent="32" bottom="0">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail indent="32" top="0" bottom="0">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail indent="32" top="0" bottom="0">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail indent="32" top="0">
                              {item?.text_3}
                            </SubDetail>
                          )}

                          {item?.text_4 && (
                            <SubHead bottom={"10"}>{item?.text_4}</SubHead>
                          )}

                          <SubDetail top="0" bottom="0" indent="32">
                            <div className="link-web public-health">
                              1) à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¸•à¸²à¸£à¸²à¸‡à¸ªà¸­à¸™à¸‚à¸­à¸‡à¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸² à¸œà¹ˆà¸²à¸™à¸£à¸°à¸šà¸š
                              <a
                                href={`http://reg.sut.ac.th/`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>reg.sut.ac.th</u>
                              </a>
                            </div>
                          </SubDetail>
                          <SubDetail top="0" bottom="0" indent="32">
                            <div className="link-web public-health">
                              2) à¸™à¸±à¸à¸¨à¸¶à¸à¸©à¸²à¸ªà¸²à¸¡à¸²à¸£à¸– E-mail
                              à¸«à¸²à¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¹„à¸”à¹‰à¹‚à¸”à¸¢à¸•à¸£à¸‡à¹€à¸žà¸·à¹ˆà¸­à¸‚à¸­à¸žà¸š
                              <a
                                href={`https://www.sut.ac.th/phone/show_dept.php?id=1100000`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥</u>
                              </a>
                            </div>
                          </SubDetail>
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.teacher?.image &&
                      departmentData?.teacher?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.activity && (
              <Element name={departmentData?.activity?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.activity?.image ? (
                        departmentData?.activity?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.activity?.title}</SubTitle>
                      {departmentData?.activity?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent={"0"}>
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent={"0"}>
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" bottom={"0"} indent={"0"}>
                                {item?.text_3}
                              </SubDetail>
                            )}

                            <SubDetail top="0" bottom="0">
                              {item?.text_4}
                            </SubDetail>

                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent={"0"}>
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0" indent={"0"}>
                                {item?.text_6}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_7}
                              </SubDetail>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_8}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_9}
                              </SubDetail>
                            )}
                            {item?.text_10 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_10}
                              </SubDetail>
                            )}
                            {item?.text_11 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_11}
                              </SubDetail>
                            )}
                            {item?.text_12 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_12}
                              </SubDetail>
                            )}
                            {item?.text_13 && (
                              <SubDetail top="0">{item?.text_13}</SubDetail>
                            )}
                            {item?.text_14 && (
                              <SubDetail bottom="0">{item?.text_14}</SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.role && (
              <Element name={departmentData?.role?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.role?.title}</SubTitle>
                    {departmentData?.role?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0" indent="32">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail bottom="0" indent="32">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" indent="32">
                              {item?.text_4}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.role?.image &&
                      departmentData?.role?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_3 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_3}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.studen_system && (
              <Element name={departmentData?.studen_system?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.studen_system?.image ? (
                        departmentData?.studen_system?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>
                        {departmentData?.studen_system?.title}
                      </SubTitle>
                      {departmentData?.studen_system?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubTitle bottom="0">{item?.text_0}</SubTitle>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}

                            {item?.text_4 && (
                              <TextBold bottom="0">{item?.text_4}</TextBold>
                            )}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLinkRegis(
                                  item?.text_5,
                                  "1) à¸¥à¸‡à¸—à¸°à¹€à¸šà¸µà¸¢à¸™à¸—à¸µà¹ˆ "
                                )}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_6}
                              </SubDetail>
                            )}

                            {item?.text_7 && (
                              <SubTitle bottom="0">{item?.text_7}</SubTitle>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_8}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" bottom="0">
                                <div className="link-web">
                                  <a
                                    href="http://iph.sut.ac.th/iph-mis/index.php/Main/IPHDocumentLoadPage/1"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <u>{item?.text_9}</u>
                                  </a>
                                </div>
                              </SubDetail>
                            )}
                            {item?.text_10 && (
                              <SubDetail top="0" bottom="0">
                                <div className="link-web">
                                  <a
                                    href="http://iph.sut.ac.th/iph-mis/index.php/Main/IPHDocumentLoadPage/2"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <u>{item?.text_10}</u>
                                  </a>
                                </div>
                              </SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData.teachter_system && (
              <Element name={departmentData.teachter_system?.title}>
                <SubTitle align="center">
                  {departmentData.teachter_system?.title}
                </SubTitle>

                <iframe
                  title="file"
                  style={{ width: "100%", height: "760px", border: "none" }}
                  src={
                    departmentData.teachter_system?.image &&
                    departmentData.teachter_system?.image[0]?.image_1
                  }
                />
              </Element>
            )}

            {departmentData.continuous_course && (
              <Element name={departmentData?.continuous_course?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle align="center">
                    {departmentData?.continuous_course?.title}
                  </SubTitle>

                  <Row gutter={24} className="row-detail-card">
                    {departmentData?.continuous_course?.text && (
                      <>
                        <Col span={8}>
                          <SubHead bottom="10">
                            {departmentData?.continuous_course?.text[0]?.text_0}
                          </SubHead>

                          {departmentData?.continuous_course?.link &&
                            departmentData?.continuous_course?.link[0]
                              ?.link_0 && (
                              <a
                                href={
                                  departmentData?.continuous_course?.link[0]
                                    ?.link_0
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <SubDetail top="0">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#EE579C",
                                    }}
                                  >
                                    <img
                                      loading="lazy"
                                      src={iconPDFPink}
                                      alt="icon file pdf"
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                                  </div>
                                </SubDetail>
                              </a>
                            )}
                        </Col>
                        <Col span={8}>
                          <SubHead bottom="10">
                            {departmentData?.continuous_course?.text[0]?.text_1}
                          </SubHead>

                          {departmentData?.continuous_course?.link &&
                            departmentData?.continuous_course?.link[0]
                              ?.link_1 && (
                              <a
                                href={
                                  departmentData?.continuous_course?.link[0]
                                    ?.link_1
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <SubDetail top="0">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#EE579C",
                                    }}
                                  >
                                    <img
                                      loading="lazy"
                                      src={iconPDFPink}
                                      alt="icon file pdf"
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                                  </div>
                                </SubDetail>
                              </a>
                            )}
                        </Col>
                        <Col span={8}>
                          <SubHead bottom="10">
                            {departmentData?.continuous_course?.text[0]?.text_2}
                          </SubHead>

                          {departmentData?.continuous_course?.link &&
                            departmentData?.continuous_course?.link[0]
                              ?.link_2 && (
                              <a
                                href={
                                  departmentData?.continuous_course?.link[0]
                                    ?.link_2
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <SubDetail top="0">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#EE579C",
                                    }}
                                  >
                                    <img
                                      loading="lazy"
                                      src={iconPDFPink}
                                      alt="icon file pdf"
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                                  </div>
                                </SubDetail>
                              </a>
                            )}
                        </Col>
                      </>
                    )}
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData.criteria && (
              <Element name={departmentData?.criteria?.title}>
                <SubTitle align="center">
                  {departmentData?.criteria?.title}
                </SubTitle>

                <Row gutter={24} className="row-detail-card" justify="center">
                  {departmentData?.criteria?.text && (
                    <>
                      <Col span={8}>
                        <SubHead bottom="10">
                          {departmentData?.criteria?.text[0]?.text_0}
                        </SubHead>
                        <a
                          href="https://iph.sut.ac.th/iph-mis/upload-file/upload_document/IPH_document_4_2025_03_05_17_42_31.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <SubDetail top="0">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#EE579C",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                loading="lazy"
                                src={iconPDFPink}
                                alt="icon file pdf"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  marginRight: "10px",
                                }}
                              />
                              <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                            </div>
                          </SubDetail>
                        </a>
                      </Col>
                      <Col span={8}>
                        <SubHead bottom="10">
                          {departmentData?.criteria?.text[0]?.text_1}
                        </SubHead>
                        <a
                          href="https://iph.sut.ac.th/iph-mis//upload-file/upload_document/IPH_document_3_2024_06_17_17_30_56.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <SubDetail top="0">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#EE579C",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                loading="lazy"
                                src={iconPDFPink}
                                alt="icon file pdf"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  marginRight: "10px",
                                }}
                              />
                              <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                            </div>
                          </SubDetail>
                        </a>
                      </Col>
                      <Col span={8}>
                        <SubHead bottom="10">
                          {departmentData?.criteria?.text[0]?.text_2}
                        </SubHead>
                        <a
                          href="https://iph.sut.ac.th/iph-mis/upload-file/upload_document/IPH_document_4_2024_03_04_11_52_52.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <SubDetail top="0">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#EE579C",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                loading="lazy"
                                src={iconPDFPink}
                                alt="icon file pdf"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  marginRight: "10px",
                                }}
                              />
                              <u>à¸”à¸¹à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡</u>
                            </div>
                          </SubDetail>
                        </a>
                      </Col>
                    </>
                  )}
                </Row>
              </Element>
            )}

            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"white"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                            return (
                              <Col
                                span={12}
                                style={{ padding: "10px" }}
                                key={index}
                              >
                                <div style={styleDetailContact}>
                                  <DetailContact
                                    color="var(--black)"
                                    title={item?.title}
                                    phone={item?.phone_1}
                                    office={item?.phone_2}
                                    facebook={item?.fb}
                                    website={item?.site}
                                    email1={item?.email_1}
                                    email2={item?.email_2}
                                    email3={item?.email_3}
                                    line={item?.line}
                                    indent={"40"}
                                    slang={slang}
                                    type="branch"
                                    index={index}
                                  />
                                </div>
                              </Col>
                            );
                          })
                        : contactData[0]?.address !== "" && (
                            <Col span={12} style={{ padding: "10px" }}>
                              <DetailContact
                                color="var(--black)"
                                title={contactData[0]?.title}
                                address={contactData[0]?.address}
                                slang={slang}
                                type="branch"
                              />
                            </Col>
                          )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}

            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>à¸•à¸±à¹‰à¸‡à¹à¸•à¹ˆà¹€à¸£à¸´à¹ˆà¸¡à¹€à¸›à¸´à¸”à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œ</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>à¸›à¸µ (à¸ž.à¸¨.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
}

export default PublicHealthDepartment;
